import React from 'react';
import { UtensilsIcon, UsersIcon, TrashIcon, PackageMinusIcon } from 'lucide-react';
export function ProblemSection() {
  const costLeaks = [{
    icon: UtensilsIcon,
    label: 'Food Costs',
    percentage: 35
  }, {
    icon: UsersIcon,
    label: 'Labor',
    percentage: 28
  }, {
    icon: TrashIcon,
    label: 'Waste',
    percentage: 18
  }, {
    icon: PackageMinusIcon,
    label: 'Inventory Loss',
    percentage: 22
  }];
  return <section className="bg-white px-6 py-16" data-id="element-32">
      <div className="max-w-2xl mx-auto space-y-8" data-id="element-33">
        <h2 className="text-slate-navy text-3xl font-manrope font-semibold leading-tight" data-id="element-34">
          Most Restaurant Owners Know Sales... But Don't Know What They Actually
          Keep.
        </h2>

        <div className="space-y-4" data-id="element-35">
          {costLeaks.map((leak, index) => {
          const Icon = leak.icon;
          return <div key={index} className="bg-white border border-gray-100 shadow-sm p-5 rounded-[8px] space-y-4" data-id="element-36">
                <div className="flex items-center gap-3" data-id="element-37">
                  <div className="w-8 h-8 flex items-center justify-center" data-id="element-38">
                    <Icon className="w-5 h-5 text-slate-navy" data-id="element-39" />
                  </div>
                  <span className="text-slate-navy font-semibold text-base" data-id="element-40">
                    {leak.label}
                  </span>
                </div>

                <div className="w-full bg-gray-100 rounded-full h-1.5 overflow-hidden" data-id="element-41">
                  <div className="bg-gray-300 h-full rounded-full" style={{
                width: `${leak.percentage}%`
              }} data-id="element-42" />
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}